import { SingleQuestionType } from '@/domain/model/question'

export const getUniqueResourceNames = (data: SingleQuestionType[]) => {
  const uniqueResourceNames = new Set()
  data.forEach((item) => {
    if (item.resource_name) {
      uniqueResourceNames.add(item.resource_name)
    }
  })

  return Array.from(uniqueResourceNames).map((resourceName) => resourceName)
}
